<nav>
  <ul>
    <li *ngFor="let item of fragments">
      <a [routerLink]="['/']" [fragment]="item.url">{{ item.label }}</a>
    </li>
  </ul>
</nav>
